import { Avatar } from '../Avatar';

// Deterministic fallback tile (D9): stable colour from the family id, first
// letter(s) from the name. Used everywhere a family identity appears.
const COLORS = [
  'red.500',
  'orange.500',
  'yellow.600',
  'green.500',
  'teal.500',
  'blue.500',
  'cyan.600',
  'purple.500',
  'pink.500',
];

export function familyColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return COLORS[Math.abs(hash) % COLORS.length]!;
}

interface FamilyAvatarProps {
  id: string;
  name: string;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function FamilyAvatar({
  id,
  name,
  src,
  size = 'md',
}: FamilyAvatarProps) {
  return (
    <Avatar
      size={size}
      name={name}
      src={src ?? undefined}
      // A family's picture is its own, opened with its key (D291).
      ownerId={id}
      familyId={id}
      // Its colour (D9) shows until a sealed picture opens, then is covered.
      bg={familyColor(id)}
      color="white"
    />
  );
}
